import { useSelector } from 'react-redux'
import forms from '@forms'

export default function useDynamicFields(page) {
  const { country } = useSelector(store => store.application)
  const fields = forms[country][page]

  return {
    fields,
  }
}
